import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { SvgVisible } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { NewBadge } from '@/app/donation/_components/NewBadge';
import { Rating } from '@/app/donation/_components/Rating';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import type { WelloPickItem } from './WelloPickSectionServer';
type PickedGiftProps = {
  onClickItem: () => void;
  isDisplayInstitution: boolean;
  className?: string;
} & WelloPickItem;
export const PickedGift = t0 => {
  const $ = _c(61);
  const {
    isDisplayInstitution,
    onClickItem,
    productNumber,
    slugId,
    productName,
    imageUrl,
    isNew,
    readCount,
    institutionId,
    institutionSlugId,
    institutionName,
    institutionLogoUrl,
    reviewRating,
    reviewCount,
    className,
    donationAmount
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-224 shrink-0", "mobile-tablet:w-140", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== productNumber || $[3] !== slugId) {
    t2 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[2] = productNumber;
    $[3] = slugId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${productName} 상세페이지로 이동`;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("relative mb-12 block h-[21.25rem] w-full", "mobile-tablet:mb-8 mobile-tablet:h-210");
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== imageUrl || $[7] !== productName) {
    t5 = <Image fill={true} className="rounded-xlarge object-cover" src={imageUrl} sizes={`${BREAKPOINTS.MOBILE_TABLET} 140px, 224px`} alt={productName} />;
    $[6] = imageUrl;
    $[7] = productName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src="https://cdn.welfarehello.com/static/donation/main/pick.png" alt="pick" width={45} height={24} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isNew) {
    t7 = isNew ? <NewBadge /> : null;
    $[10] = isNew;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="absolute left-0 top-0 flex items-center">{t6}{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute inset-0 rounded-xlarge bg-gradient-to-b from-transparent from-75% to-Gray-black/40" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SvgVisible className="size-14 text-Gray-white" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== readCount) {
    t11 = readCount?.toLocaleString();
    $[16] = readCount;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <div className="absolute bottom-0 left-0 flex w-full items-center justify-center gap-2 truncate rounded-b-xlarge bg-gradient-to-t from-Gray-black/40 to-transparent pb-12">{t10}<p className="font-600 text-Gray-white typo-caption1">{t11}명이 보는 중</p></div>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== onClickItem || $[21] !== t12 || $[22] !== t2 || $[23] !== t3 || $[24] !== t5 || $[25] !== t8) {
    t13 = <CustomLink href={t2} aria-label={t3} className={t4} onClick={onClickItem}>{t5}{t8}{t9}{t12}</CustomLink>;
    $[20] = onClickItem;
    $[21] = t12;
    $[22] = t2;
    $[23] = t3;
    $[24] = t5;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== institutionId || $[28] !== institutionLogoUrl || $[29] !== institutionName || $[30] !== institutionSlugId || $[31] !== isDisplayInstitution) {
    t14 = isDisplayInstitution && <CustomLink href={DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
      id: institutionSlugId ?? institutionId
    })} className="flex items-center gap-4 pb-4"><div className={cn("relative size-24 overflow-hidden rounded-pill border border-Gray-300", "mobile-tablet:size-20")}><Image fill={true} src={institutionLogoUrl} alt={institutionName} className="object-cover" sizes={`${BREAKPOINTS.MOBILE_TABLET} 20px, 24px`} /></div><p className={cn("pt-2 font-600 text-Gray-600 typo-body4", "mobile-tablet:font-600 mobile-tablet:typo-caption1")}>{institutionName}</p><SvgChevronright className={cn("size-16 text-Gray-600", "mobile-tablet:size-12")} /></CustomLink>;
    $[27] = institutionId;
    $[28] = institutionLogoUrl;
    $[29] = institutionName;
    $[30] = institutionSlugId;
    $[31] = isDisplayInstitution;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = cn("mb-8 line-clamp-2 font-500 text-Gray-800 typo-body3", "mobile-tablet:font-500 mobile-tablet:typo-body4");
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== productNumber || $[35] !== slugId) {
    t16 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[34] = productNumber;
    $[35] = slugId;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = `${productName} 상세페이지로 이동`;
  let t18;
  if ($[37] !== onClickItem || $[38] !== productName || $[39] !== t16 || $[40] !== t17) {
    t18 = <CustomLink className={t15} href={t16} aria-label={t17} onClick={onClickItem}>{productName}</CustomLink>;
    $[37] = onClickItem;
    $[38] = productName;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = cn("mb-2 flex items-center gap-4", "mobile-tablet:hidden");
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== donationAmount) {
    t20 = donationAmount.toLocaleString();
    $[43] = donationAmount;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="font-600 typo-body3">원</span>;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t20) {
    t22 = <p className="font-700 text-Gray-black typo-body2">{t20}{t21}</p>;
    $[46] = t20;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="font-600 text-Gray-550 typo-body3">기부시 증정</p>;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t22) {
    t24 = <div className={t19}>{t22}{t23}</div>;
    $[49] = t22;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== reviewCount || $[52] !== reviewRating) {
    t25 = <Rating value={reviewRating} count={reviewCount} size={12} />;
    $[51] = reviewCount;
    $[52] = reviewRating;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t1 || $[55] !== t13 || $[56] !== t14 || $[57] !== t18 || $[58] !== t24 || $[59] !== t25) {
    t26 = <article className={t1}>{t13}{t14}{t18}{t24}{t25}</article>;
    $[54] = t1;
    $[55] = t13;
    $[56] = t14;
    $[57] = t18;
    $[58] = t24;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  return t26;
};